import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from 'app/src/queries/withCount';

export const TXN_LINES_WITH_COUNT = gql`
  query TxnLinesWithCount (
    ${WITH_COUNT_VARIABLES}
    $resourceType: String
    $resourceId: ID
  ) {
    txnLinesWithCount(
      ${WITH_COUNT_ARGUMENTS}
      resourceType: $resourceType
      resourceId: $resourceId
    ) {
      entries {
        id
        txn {
          id
        }
        account {
          name
        }
        debitLessCredit
        creditLessDebit
        asset {
          stockNumber
        }
        saleAsset {
          lotNumber
          sale { saleOn }
        }
        fee {
          type
        }
        txn {
          bankDate
        }
      }
      count
    }
    resource (
      type: $resourceType
      id: $resourceId
    ) {
      name
      path
    }
  }
`;
